<!-- @format -->

<template>
    <div class="gst-booking-payment-summary gst-septenary-border gst-rounded-xs pa-4 mb-2 mb-md-0">
        <div class="d-flex justify-space-between align-center">
            <h4>{{ $t(flow + '.totalTitle') }}</h4>
            <h4>
                {{ totalAmount }}
            </h4>
        </div>

        <slot name="action"></slot>

        <p>{{ $t(flow + '.infoText') }}</p>
        <p>{{ $t(flow + '.infoSubtext') }}</p>
    </div>
</template>

<script>
export default {
    name: 'BookingPaymentSummary',
    props: {
        totalAmount: {
            type: String,
            default: null,
        },
        flow: {
            type: String,
            default: 'refund',
            validator: function (value) {
                return ['refund', 'replace'].includes(value);
            },
        },
    },
    i18nOptions: {
        namespaces: 'main',
        keyPrefix:
            'modules.hotel.features.manageBooking.theManageBookingCheckout._components.bookingPaymentSummary',
    },
};
</script>

<style lang="scss" scoped>
@import '@scssMixins';
@import '@scssVariables';

.gst-booking-payment-summary {
    h4 {
        color: theme-color('quaternary');
        font-weight: font-weight('large');
    }

    p {
        margin-bottom: 0;
        color: theme-color('quaternary');
        font-size: font-size('xxs');
        font-weight: font-weight('regular');
    }

    p:first-of-type {
        margin-bottom: 8px;
        font-weight: font-weight('large');
    }

    .gst-checkout-action__pay-later {
        p {
            font-size: font-size('s');
            font-weight: font-weight('large');
        }

        .gst-checkout-action__tooltip-activator {
            margin-top: 2px !important;
            margin-left: theme-spacing(2) !important;
        }
    }

    .gst-checkout-action__tooltip-activator {
        margin-top: 2px !important;
        margin-left: theme-spacing(2) !important;
    }

    .gst-base-form-checkbox {
        font-size: font-size('s');
        font-weight: font-weight('large');
    }
}
</style>
